module.exports = __webpack_public_path__ + "img/plusIcon.2827762c.svg";